import axios from 'axios'
import { UtilUrl } from './utilUrl';

export class AuthServices {

    requestPost(body: any, indexUrl: number): Promise<any> {

        const { url, actionRoute, urlEntornoLocal, urlDominioServidor, urlEntornoLambda, urlEntornoLambdaProxy } = UtilUrl();
        let urlRq: string;
        let headers: any;
        let rqBody: any;
        const f = new FormData();

        switch (actionRoute) {
            case 'LOCAL':
                headers = {
                    'Content-Type': 'application/json'
                }
                urlRq = `${urlEntornoLocal}${url[indexUrl].pathLambda}`;
                rqBody = body;
                break;
            case 'PROXY':
                headers = {
                    'Content-Type': 'multipart/form-data'
                }
                f.append('urlPath', `${urlDominioServidor}${url[indexUrl].pathLambdaProxy}`)
                f.append('body', JSON.stringify(body))
                urlRq = `${urlEntornoLambdaProxy}`;
                rqBody = f;
                break;
            case 'LAMBDA':
                headers = {
                    'Content-Type': 'application/json'
                }
                urlRq = `${urlEntornoLambda}${url[indexUrl].pathLambda}`;
                rqBody = body;
                break;
        }

        return new Promise((resolve, reject) => {
            axios.post(urlRq, rqBody, {
                headers
            }).then((response) => {
                resolve(response.data)
            }).catch((error) => {
                reject(error)
            })
        })
    }

    requestPutFileUrlPresigned(fileBase64: string, presignedUrl: string): Promise<any> {
        const headers = {
            'Content-Type': 'text/plain',
        }
        return new Promise((resolve, reject) => {
            axios.put(presignedUrl, fileBase64, {
                headers
            }).then((response) => {
                resolve(response.data)
            }).catch((error) => {
                reject(error)
            })
        })
    }

    requestGetFileUrlS3(S3Url: string): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.get(S3Url, {
                responseType: 'text',
            }).then((response) => {
                resolve(response.data)
            }).catch((error) => {
                reject(error)
            })
        })
    }

}